(function () {
  'use strict';

  if (window.blog2026UiLoaded) return;
  window.blog2026UiLoaded = true;

  var mobileQuery = window.matchMedia('(max-width: 959px)');
  var resizeFrame = 0;

  function fitAsciiEllipsis(element) {
    if (!element.dataset.blogFullText) {
      element.dataset.blogFullText = element.textContent.trim();
    }

    var fullText = element.dataset.blogFullText;
    element.textContent = fullText;

    if (!mobileQuery.matches || !fullText) return;

    var lineCount = parseInt(element.dataset.lines || '1', 10);
    var lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
    var allowedHeight = lineHeight * lineCount + 0.5;
    if (element.scrollHeight <= allowedHeight) return;

    var suffix = '...';
    var low = 0;
    var high = fullText.length;
    var best = suffix;

    while (low <= high) {
      var middle = Math.floor((low + high) / 2);
      var candidate = fullText.slice(0, middle).trimEnd() + suffix;
      element.textContent = candidate;

      if (element.scrollHeight <= allowedHeight) {
        best = candidate;
        low = middle + 1;
      } else {
        high = middle - 1;
      }
    }

    element.textContent = best;
  }

  function fitAllTitles(root) {
    (root || document).querySelectorAll('[data-blog-ascii-ellipsis]').forEach(fitAsciiEllipsis);
  }

  /* Shopify CDN 偶发只让某个宽度变体失败时，移除 srcset 并切到同源大图一次。
     正常图片不改请求、不重复加载；同一元素最多回退一次，避免 error 循环。 */
  function useImageFallback(image) {
    var fallback = image.dataset.blogImageFallback;
    if (!fallback || image.dataset.blogImageFallbackTried === 'true') return;
    image.dataset.blogImageFallbackTried = 'true';
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = fallback;
  }

  function initImageFallback(root) {
    (root || document).querySelectorAll('img[data-blog-image-fallback]').forEach(function (image) {
      if (image.dataset.blogImageFallbackBound === 'true') return;
      image.dataset.blogImageFallbackBound = 'true';
      image.addEventListener('error', function () {
        useImageFallback(image);
      });
      if (image.complete && image.naturalWidth === 0) useImageFallback(image);
    });
  }

  function pageUrl(page) {
    var url = new URL(window.location.href);
    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(page));
    }
    return url.pathname + url.search + url.hash;
  }

  function pagerItem(label, page, current, disabled, ariaLabel) {
    var element = document.createElement(disabled || current ? 'span' : 'a');
    element.className = 'bl26-pager__item';

    if (current) {
      element.classList.add('bl26-pager__item--current');
      element.setAttribute('aria-current', 'page');
    } else if (disabled) {
      element.classList.add('bl26-pager__item--disabled');
      element.setAttribute('aria-hidden', 'true');
    } else {
      element.href = pageUrl(page);
    }

    if (ariaLabel && !disabled) element.setAttribute('aria-label', ariaLabel);
    element.textContent = label;
    return element;
  }

  function pagerArrow(page, direction, disabled) {
    var element = pagerItem('', page, false, disabled, direction < 0 ? 'Previous page' : 'Next page');
    element.innerHTML =
      '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
      '<path d="' +
      (direction < 0 ? 'M9 2L4 7l5 5' : 'M5 2l5 5-5 5') +
      '" stroke="#071d49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    return element;
  }

  function pagerGap() {
    var element = document.createElement('span');
    element.className = 'bl26-pager__item bl26-pager__item--gap';
    element.textContent = '...';
    element.setAttribute('aria-hidden', 'true');
    return element;
  }

  function visiblePageNumbers(currentPage, pageCount) {
    if (pageCount <= 7) {
      return Array.from({ length: pageCount }, function (_, index) {
        return index + 1;
      });
    }

    var numbers = [1, pageCount];
    for (var page = currentPage - 1; page <= currentPage + 1; page += 1) {
      if (page > 1 && page < pageCount) numbers.push(page);
    }
    return numbers.sort(function (a, b) {
      return a - b;
    });
  }

  function initPagination(root) {
    var cards = Array.from(root.querySelectorAll('[data-bl26-card]'));
    var pager = root.querySelector('[data-bl26-pager]');
    var pageSize = parseInt(root.dataset.pageSize || '6', 10);
    if (!cards.length || !pager || !pageSize) return;

    var pageCount = Math.max(1, Math.ceil(cards.length / pageSize));
    var requestedPage = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    var currentPage = Math.min(Math.max(requestedPage || 1, 1), pageCount);
    var firstIndex = (currentPage - 1) * pageSize;
    var lastIndex = firstIndex + pageSize;

    cards.forEach(function (card, index) {
      card.hidden = index < firstIndex || index >= lastIndex;
    });

    pager.replaceChildren();
    if (pageCount <= 1) {
      pager.hidden = true;
      return;
    }

    pager.hidden = false;
    pager.appendChild(pagerArrow(currentPage - 1, -1, currentPage === 1));

    var numbers = visiblePageNumbers(currentPage, pageCount);
    numbers.forEach(function (page, index) {
      if (index > 0 && page - numbers[index - 1] > 1) pager.appendChild(pagerGap());
      pager.appendChild(pagerItem(String(page), page, page === currentPage, false));
    });

    pager.appendChild(pagerArrow(currentPage + 1, 1, currentPage === pageCount));
  }

  function initialize(root) {
    (root || document).querySelectorAll('[data-bl26-pagination]').forEach(initPagination);
    initImageFallback(root);
    fitAllTitles(root);
  }

  function scheduleTitleFit() {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      fitAllTitles(document);
    });
  }

  initialize(document);
  window.addEventListener('resize', scheduleTitleFit, { passive: true });
  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', scheduleTitleFit);
  } else {
    mobileQuery.addListener(scheduleTitleFit);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      fitAllTitles(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
